import { render, staticRenderFns } from "./AddBus.vue?vue&type=template&id=5784c948&scoped=true&"
import script from "./AddBus.vue?vue&type=script&lang=js&"
export * from "./AddBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784c948",
  null
  
)

export default component.exports